interface IMinerReproxyCacheItemValue {
  port?: number;
  time?: number;
}

// не актуально

const TIMEOUT_MINUTES_MS = 4 * 60 * 1000 + 55 * 1000; // 4 minutes and 55 seconds

export default function useMinerReproxyPortsCache() {

  function set(
    minerId: number,
    port: number,
    time: number
  ) {
    localStorage.setItem(`REPROXY_${minerId}`, JSON.stringify({ port, time }));
  }

  function remove(minerId: number) {
    localStorage.removeItem(`REPROXY_${minerId}`);
  }

  function isAlive(minerId: number, port: number) {
    try {
      const raw = localStorage.getItem(`REPROXY_${minerId}`);
      if (!raw) return false;
      const item = JSON.parse(raw) as IMinerReproxyCacheItemValue;
      if (!item) return false;
      if (item.port !== port) return false;
      // Check if the item is older than 5 minutes
      if (item.time && Date.now() - item.time > TIMEOUT_MINUTES_MS) {
        remove(minerId);
        return false;
      }
      return true;
    } catch {
      remove(minerId);
      return false;
    }
  }

  return {
    set,
    remove,
    isAlive
  }
} 